import React, { useEffect } from 'react';
const setupBlogMotion = require('./blogMotion');

const { isBlogPath, metadata, renderBlog } = require('./blogRender');
export { isBlogPath };

export default function BlogPage({ path }) {
    useEffect(() => setupBlogMotion(document), [path]);
    useEffect(() => {
        const info = metadata(path);
        const oldTitle = document.title;
        document.title = info.title;
        const description = document.querySelector('meta[name="description"]');
        const canonical = document.querySelector('link[rel="canonical"]');
        const oldDescription = description?.getAttribute('content');
        const oldCanonical = canonical?.getAttribute('href');
        description?.setAttribute('content', info.description);
        canonical?.setAttribute('href', info.url);
        const socialUpdates = [
            ['meta[property="og:title"]', 'content', info.title],
            ['meta[property="og:description"]', 'content', info.description],
            ['meta[property="og:url"]', 'content', info.url],
            ['meta[property="og:type"]', 'content', info.article ? 'article' : 'website'],
            ['meta[property="og:image"]', 'content', info.image],
            ['meta[name="twitter:title"]', 'content', info.title],
            ['meta[name="twitter:description"]', 'content', info.description],
            ['meta[name="twitter:image"]', 'content', info.image],
        ].map(([selector, attribute, value]) => {
            const element = document.querySelector(selector);
            const previous = element?.getAttribute(attribute);
            element?.setAttribute(attribute, value);
            return { element, attribute, previous };
        });
        const schema = document.createElement('script');
        schema.type = 'application/ld+json';
        schema.textContent = JSON.stringify(info.schema).replace(/</g, '\\u003c');
        document.head.appendChild(schema);
        return () => {
            document.title = oldTitle;
            if (oldDescription !== null && oldDescription !== undefined) description?.setAttribute('content', oldDescription);
            if (oldCanonical !== null && oldCanonical !== undefined) canonical?.setAttribute('href', oldCanonical);
            socialUpdates.forEach(({ element, attribute, previous }) => {
                if (previous !== null && previous !== undefined) element?.setAttribute(attribute, previous);
            });
            schema.remove();
        };
    }, [path]);

    return <div dangerouslySetInnerHTML={{ __html: renderBlog(path) }} />;
}
